import React, { useState, useEffect } from 'react';

const digitalMarketingTestimonialsData = [
  {
    id: 1,
    quote:
      'Experts Communication completely overhauled our digital marketing approach. Within 4 months, our organic search traffic exploded by 210% and our customer acquisition cost dropped by 45%. Their data-driven strategy is second to none.',
    author: 'Harrison Vance',
    designation: 'CMO, NovaBrand Global',
    avatar: '/assets/images/team_member_1.png'
  },
  {
    id: 2,
    quote:
      'Their social media advertising campaigns scaled our monthly revenue from $40k to over $180k with a consistent 4.2x ROAS. They don’t just run ads; they craft full-funnel strategies that convert casual visitors into repeat buyers.',
    author: 'Samantha Reed',
    designation: 'VP of Marketing, Velocity Retail',
    avatar: '/assets/images/team_member_2.png'
  },
  {
    id: 3,
    quote:
      'Finding a digital marketing agency in Karachi that truly understands Google SEO and targeted PPC is rare. Experts Communication ranked us on page 1 for all our high-intent commercial keywords. Exceptional team and service!',
    author: 'Zubair Ahmed',
    designation: 'Founder, TechPeak Logistics',
    avatar: '/assets/images/team_member_3.png'
  },
  {
    id: 4,
    quote:
      'From viral TikTok and Meta campaigns to high-converting email marketing sequences, their multi-channel strategy transformed our digital presence. They provide transparent weekly reporting and proactive optimization every single step of the way.',
    author: 'Chloe Montgomery',
    designation: 'Brand Director, Luxe Apparel Group',
    avatar: '/assets/images/hr-manager.jpg'
  }
];

function DigitalMarketingTestimonialsSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto slide smoothly every 4.5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % digitalMarketingTestimonialsData.length);
    }, 4500);

    return () => clearInterval(timer);
  }, []);

  const handleDiscussClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('digital-marketing-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  const currentTestimonial = digitalMarketingTestimonialsData[currentIndex];

  return (
    <section className="ecom-testimonial-section">
      <div className="container bpo-testimonial-container">
        {/* Left Column: Headings, Sliding Card, and Button */}
        <div className="bpo-testimonial-left">
          <span className="bpo-testimonial-tag">
            What clients say about our marketing!
          </span>

          <h2 className="bpo-testimonial-title">
            Delivering Measurable ROI That <span className="text-red">Scales Businesses</span>
          </h2>

          <p className="bpo-testimonial-desc">
            Discover authentic feedback and success stories from startup founders, business owners, and global brands whose online identity and revenue were multiplied by Experts Communication’s digital marketing team.
          </p>

          {/* Testimonial Card */}
          <div className="bpo-testimonial-card-wrapper">
            <div className="bpo-testimonial-card" key={currentTestimonial.id}>
              {/* Star Rating */}
              <div className="bpo-stars-row">
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
              </div>

              {/* Review Quote Text */}
              <p className="bpo-quote-text">
                "{currentTestimonial.quote}"
              </p>

              {/* Client Info & Quotation Icon */}
              <div className="bpo-client-row">
                <div className="bpo-client-info">
                  <img 
                    src={currentTestimonial.avatar} 
                    alt={currentTestimonial.author} 
                    className="bpo-client-avatar"
                  />
                  <div className="bpo-client-details">
                    <h4 className="bpo-client-name">{currentTestimonial.author}</h4>
                    <span className="bpo-client-role">{currentTestimonial.designation}</span>
                  </div>
                </div>

                {/* Quotation Symbol */}
                <div className="bpo-quote-icon">
                  <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="rgba(255, 255, 255, 0.4)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.75-2-2-2H4c-1.25 0-2 .75-2 2v6c0 1.25.75 2 2 2h4c0 4-2 6-5 8z" />
                    <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.75-2-2-2h-4c-1.25 0-2 .75-2 2v6c0 1.25.75 2 2 2h4c0 4-2 6-5 8z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Action Button */}
          <button className="btn-bpo-explore" onClick={handleDiscussClick}>
            Let's Discuss Your Growth
          </button>
        </div>

        {/* Right Column: 5-Star Reviews Showcase Graphic */}
        <div className="bpo-testimonial-right">
          <div className="bpo-reviews-img-wrapper">
            <img 
              src="/assets/images/bpo_reviews_neon.jpg" 
              alt="5-Star Digital Marketing Client Reviews Showcase" 
              className="bpo-reviews-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default DigitalMarketingTestimonialsSlider;
